import { z } from 'zod'

export const PayCurvePayoutSchema = z.union([z.number().finite().nonnegative(), z.string()])

export const PayCurvePointSchema = z
  .object({
    attainment: z.number().finite().nonnegative(),
    payout: PayCurvePayoutSchema
  })
  .strict()

export const PayCurveConfigSchema = z
  .object({
    points: z.array(PayCurvePointSchema),
    quota: z.number().finite().nonnegative().optional(),
    targetIncentive: z.number().finite().nonnegative().optional(),
    currency: z.string().trim().min(1).optional()
  })
  .strict()

export const PayCurveSimulationProfileSchema = z
  .object({
    imgUrl: z.string().url().optional(),
    name: z.string().trim().min(1),
    attainment: z.number().finite().nonnegative(),
    variablePay: z.number().finite().nonnegative(),
    metricValue: z.number().finite().nonnegative().optional(),
    quota: z.number().finite().nonnegative().optional()
  })
  .strict()

export const PayCurveSimulationProfilesSchema = z.array(PayCurveSimulationProfileSchema)
